import Grid from '@mui/material/Grid';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { DateRangePicker, DateRange, LocalizationProvider } from '@mui/x-date-pickers-pro';
import dayjs, { Dayjs } from 'dayjs';
import { useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';

import 'dayjs/locale/de';
import DelayCommListGrid from './DelayCommListGrid';
import CreateDelayCommEventDialog from './CreateDelayCommEventDialog';
import { Message } from '@aviation/cabinapp-message-service-sdk';

function DelayComm() {
    const [dateRange, setDateRange] = useState<DateRange<Dayjs>>([dayjs(), dayjs().add(1, 'day')]);
    const [showCreateDialog, setShowCreateDialog] = useState(false);
    const [addedItem, setAddedItem] = useState<Message | undefined>(undefined);

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                
                <Paper sx={{ p: 2, paddingBottom: 2 , display: 'flex', flexWrap: 'wrap', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center' }} elevation={3}>
                <Box sx={{flexGrow: 1, mr: { xs: 0, md: 2 }, mb: { xs: 2, md: 0 } }}>
                        <Typography variant="subtitle1" component="h2" sx={{ textTransform: 'uppercase' }}>
                            Delay Communication
                        </Typography>
                        <Stack direction='row' spacing={2} style={{float:'right', marginTop:-20}}>
                            <Button variant="contained" onClick={() => setShowCreateDialog(true) }>Create</Button>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
                                <DateRangePicker value={dateRange} format='DD.MM.YYYY' onChange={(v, c) => { setDateRange(v); setAddedItem(undefined) }} slotProps={{ textField: { size: 'small' } }} />
                            </LocalizationProvider>
                        </Stack>
                    </Box>
                    </Paper>
            </Grid>
            <Grid item xs={12}>
                <Paper sx={{ p: 0, display: 'flex', flexDirection: 'column', minHeight: '100px' }} elevation={3}>
                    <DelayCommListGrid addedItem={addedItem} dateFrom={dateRange[0]?.format("YYYY-MM-DD")} dateTo={dateRange[1]?.format("YYYY-MM-DD")} />
                </Paper>
            </Grid>

            { showCreateDialog && <CreateDelayCommEventDialog cancelAction={() => { setShowCreateDialog(false)}} createAction={(item) => { setShowCreateDialog(false); setAddedItem(item)}} />}
        </Grid>
    );
}

export default DelayComm;